// extracted by mini-css-extract-plugin
export default {"text":"QEsHFuuq_SyUmLaXIRTS"};